import { render, staticRenderFns } from "./SiteNotAvailableTid5.vue?vue&type=template&id=6a0a8c08&scoped=true"
import script from "./SiteNotAvailableTid5.vue?vue&type=script&lang=js"
export * from "./SiteNotAvailableTid5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a8c08",
  null
  
)

export default component.exports